module.exports = __webpack_public_path__ + "img/no_2.bb39afb1.png";